import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en.json'
import pt from './pt.json'
import es from './es.json'
import zh from './zh.json'
import ru from './ru.json'
import { pickLanguage } from '../lib/pickLanguage'

const detectLanguage = (): string =>
  pickLanguage(window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code || navigator.language)

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      pt: { translation: pt },
      es: { translation: es },
      zh: { translation: zh },
      ru: { translation: ru },
    },
    lng: detectLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
